module.exports = __webpack_public_path__ + "img/3.20e7bd2d.jpg";